import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_ID_VERIFICATION_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_ID_VERIFICATION> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_ID_VERIFICATION,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_ID_VERIFICATION);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_ID_VERIFICATION> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_ID_VERIFICATION = {
	// "0":"ButtonSubmit3",
	// "1":"ButtonSubmit2",
	// "2":"ButtonSubmit1",
	// "3":"ButtonSubmit0",
	idExpiryDate: 'Text31231231123123',
	date: 'text324234',
	name: 'CC001',
	descriptionOfBusiness3: 'Text80',
	recordReferredTo3: 'Text94',
	sourceOfElectronicVersion3: 'Text95',
	placeOfRegistration3: 'Text93',
	corporationRegistrationNumber3: 'Text92',
	entityType3: 'Text91',
	corporationName3: 'Text88',
	descriptionOfBusiness2: 'Text79',
	recordReferredTo2: 'Text87',
	sourceOfElectronicVersion2: 'Text86',
	placeOfRegistration2: 'Text85',
	corporationRegistrationNumber2: 'Text84',
	entityType2: 'Text78',
	corporationName2: 'Text75',
	descriptionOfBusiness: 'Text74',
	recordReferredTo: 'Text72',
	sourceOfElectronicVersion: 'Text73',
	placeOfRegistration: 'Text71',
	corporationRegistrationNumber: 'Text70',
	entityType: 'Text69',
	corporationName: 'Text66',
	employmentStatus3: 'Text8',
	idExpiryDate3: 'Text7',
	occupation3: 'Text64',
	idCountry3: 'Text60',
	idNumber3: 'Text59',
	idType3: 'Text58',
	mortgagorFullAddress3: 'Text3',
	mortgagorDateOfBirth3: 'Text57',
	mortgagorNameAndTitle3: 'Text56',
	employmentStatus2: 'Text6',
	idExpiryDate2: 'Text5',
	occupation2: 'Text55',
	idCountry2: 'Text51',
	idNumber2: 'Text50',
	idType2: 'Text49',
	employmentStatus: 'Text4',
	mortgagorFullAddress2: 'Text2',
	mortgagorDateOfBirth2: 'Text47',
	mortgagorNameAndTitle2: 'Text48',
	occupation: 'Text46',
	idCountry: 'Text42',
	idNumber: 'Text41',
	idType: 'Text40',
	mortgagorFullAddress: 'Text1',
	mortgagorDateOfBirth: 'Text39',
	mortgagorNameAndTitle: 'Text38',
};

export interface BMO_CONVENTIONAL_ID_VERIFICATION {
	mortgagorNameAndTitle: string;
	mortgagorDateOfBirth: string;
	mortgagorFullAddress: string;
	idType: string;
	idNumber: string;
	idCountry: string;
	idExpiryDate: string;
	occupation: string;
	employmentStatus: string;

	mortgagorNameAndTitle2: string;
	mortgagorDateOfBirth2: string;
	mortgagorFullAddress2: string;
	idType2: string;
	idNumber2: string;
	idCountry2: string;
	idExpiryDate2: string;
	occupation2: string;
	employmentStatus2: string;

	mortgagorNameAndTitle3: string;
	mortgagorDateOfBirth3: string;
	mortgagorFullAddress3: string;
	idType3: string;
	idNumber3: string;
	idCountry3: string;
	idExpiryDate3: string;
	occupation3: string;
	employmentStatus3: string;

	corporationName: string;
	entityType: string;
	corporationRegistrationNumber: string;
	placeOfRegistration: string;
	sourceOfElectronicVersion: string;
	recordReferredTo: string;
	descriptionOfBusiness: string;

	corporationName2: string;
	entityType2: string;
	corporationRegistrationNumber2: string;
	placeOfRegistration2: string;
	sourceOfElectronicVersion2: string;
	recordReferredTo2: string;
	descriptionOfBusiness2: string;

	corporationName3: string;
	entityType3: string;
	corporationRegistrationNumber3: string;
	placeOfRegistration3: string;
	sourceOfElectronicVersion3: string;
	recordReferredTo3: string;
	descriptionOfBusiness3: string;

	name: string;
	date: string;
}
